<div class="search-filters-box">
    <div class="search-text-block">
        <input [(ngModel)]="searchText" (keyup)="filterSources()" placeholder="Search" class="search-box">
        <mat-icon class="mat-icon-custom" matPrefix>search</mat-icon>
    </div>

    <select class="categories-select" [(ngModel)]="chosenCategory" (change)="filterSources()">
    <option value='all' selected>All Categories</option>
    <option *ngFor="let category of categories"
    [value]="category" >
    {{category}}
    </option>
  </select>
</div>

<div class="all-datasources-datawarehouses">
  
  <!-- <div class="each-datasource-wrapper" *ngFor="let selectedDatasource of datasources"
  [hidden]="!(selectedDatasource.displayName | filter : searchText) || (!(selectedDatasource.category.category | filter : chosenCategory) && !(chosenCategory == 'all') )">
    <div class="each-datasource" (click)="userDataSourceLogin(selectedDatasource)">
      <div>
        <div class="image-wrapper">
          <img src="../assets/images/source-logos/{{selectedDatasource.logoUrl}}">
        </div>
        <div>
          <p class="datasource-display-name">{{selectedDatasource.displayName}}</p>
          <p class="datasource-display-category">{{selectedDatasource.category.category}}</p>
          <p class="configure-divider"></p>
          <p class="configure-block"><span><img class="configure-image" src="../assets/images/configure-new.png"></span><span class="configure-text">Configure</span></p>
        </div>
      </div>
    </div>
  </div> -->





  <div class="each-datasource-wrapper" *ngFor="let selectedDatasource of filteredDatasources">
      <div class="each-datasource" (click)="userDataSourceLogin(selectedDatasource)">
          <span class="beta-icon" *ngIf="selectedDatasource.beta"></span>
          <div>
              <div class="image-wrapper">
                  <img class="image-1-src" src="../assets/images/source-logos/pngFormat/{{selectedDatasource.logoUrl}}">
              </div>
              <div>
                  <p class="datasource-display-name">{{selectedDatasource.displayName}}</p>
                  <p class="datasource-display-category">{{selectedDatasource.categoryName}}</p>
                  <!-- <p>{{selectedDatasource.displayDesc}}</p> -->
                  <p class="configure-divider"></p>
                  <p class="configure-block"><span><img class="configure-image" src="../assets/images/configure-new.png"></span><span class="configure-text">Configure</span></p>
              </div>
          </div>
      </div>

      <div *ngIf="!(filteredDatasources.length)" class="no-results">No results found</div>













    </div>
